var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEdcCalendar = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#F9F9F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4461 12.5H33.4007V14.4333H34.604C35.3725 14.4387 36.1079 14.7439 36.6502 15.2827C37.1924 15.8214 37.498 16.5502 37.5 17.3104C37.5 22.9916 37.5 28.6729 37.5 34.3541C37.4993 35.1145 37.1944 35.8437 36.6518 36.3824C36.1091 36.921 35.3727 37.2253 34.604 37.2286C28.2021 37.2286 21.7993 37.2286 15.3957 37.2286C14.9001 37.2405 14.4108 37.119 13.9796 36.8771C13.5483 36.6351 13.1917 36.2818 12.9477 35.855C12.7646 35.4916 12.6147 35.1128 12.5 34.723V16.9441C12.5169 16.9172 12.5299 16.8881 12.5386 16.8576C12.6546 16.1559 13.0273 15.5208 13.5859 15.0733C14.1445 14.6258 14.85 14.3971 15.5681 14.4308C15.9075 14.4435 16.2471 14.4308 16.5968 14.4308V12.5H18.5514V14.4181H31.4436L31.4461 12.5ZM14.452 21.5917V21.8461C14.452 25.9586 14.452 30.0711 14.452 34.1837C14.4341 34.3366 14.4515 34.4916 14.5029 34.6369C14.5543 34.7822 14.6386 34.914 14.749 35.0225C14.8594 35.131 14.9932 35.2133 15.1405 35.2632C15.2877 35.3131 15.4447 35.3293 15.5991 35.3106H34.3933C34.5499 35.3311 34.709 35.3156 34.8586 35.2655C35.0081 35.2153 35.1437 35.1318 35.2554 35.0214C35.367 34.9109 35.4517 34.7765 35.5024 34.6286C35.5532 34.4807 35.5687 34.3232 35.548 34.1684C35.548 30.0644 35.548 25.9603 35.548 21.8562V21.6019L14.452 21.5917ZM14.452 19.6329H35.5401C35.5401 18.8443 35.5555 18.0735 35.5401 17.3028C35.5443 17.0772 35.4622 16.8585 35.31 16.6905C35.1578 16.5225 34.9469 16.4177 34.7198 16.3972C34.2761 16.3745 33.8316 16.3745 33.3878 16.3972V18.2949H31.4408V16.3819H18.5488V18.2821H16.5943V16.3641H16.3011C16.0079 16.3641 15.7146 16.3641 15.4215 16.3641C15.1728 16.362 14.9336 16.4565 14.7547 16.6273C14.5758 16.7981 14.4716 17.0315 14.4649 17.2773C14.4366 18.0557 14.4649 18.8342 14.4649 19.6278",
    fill: "#00BCDA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1606 23.6242H16.2292V25.5219H18.1606V23.6242Z",
    fill: "#00BCDA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0566 23.6191H20.1304V25.527H22.0566V23.6191Z",
    fill: "#00BCDA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9578 23.6217H24.0342V25.5245H25.9578V23.6217Z",
    fill: "#00BCDA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8644 23.6293H27.9434V25.5321H29.8644V23.6293Z",
    fill: "#00BCDA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7785 23.6242H31.8472V25.5219H33.7785V23.6242Z",
    fill: "#00BCDA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.15 27.4908H16.2314V29.4013H18.15V27.4908Z",
    fill: "#00BCDA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0618 27.4908H20.1382V29.3911H22.0618V27.4908Z",
    fill: "#00BCDA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9578 27.4857H24.0342V29.3885H25.9578V27.4857Z",
    fill: "#00BCDA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8641 27.4857H27.9404V29.386H29.8641V27.4857Z",
    fill: "#00BCDA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7785 27.4857H31.8523V29.3885H33.7785V27.4857Z",
    fill: "#00BCDA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1528 31.3524H16.2214V33.2526H18.1528V31.3524Z",
    fill: "#00BCDA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.054 31.3575H20.1304V33.2603H22.054V31.3575Z",
    fill: "#00BCDA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9603 31.3575H24.0366V33.2603H25.9603V31.3575Z",
    fill: "#00BCDA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8645 31.3422H27.9512V33.2526H29.8645V31.3422Z",
    fill: "#00BCDA"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEdcCalendar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/edc-calendar.a85c19e9239f8063ae2e7da34968396b.svg";